import React, { useState } from "react";

const MessageRedirect = (props) => {

  const [onClick , setOnClick] = useState(false)
  const code = props.item && props.item.code;
  const url = props.item.url;
  const data = props.item && props.item.text_data;

  return (
    <div className="a1-wrap">
      <span
        // className={
        //   !onClick
        //     ? "chat-label action-tab action-button"
        //     : "chat-label-select action-tab"
        // }
        id="main-tab1"
      >
        {data && data.data ? (
          <form
            target="targetWindow"
            action={!props.disable && url}
            method="POST"
          >
            <input
              type="hidden"
              name={Object.keys(data.data)[0]}
              value={data.data[Object.keys(data.data)[0]]}
            ></input>
            <input
              type="submit"
              value={props.item.text}
              onClick={() => {
                if (!props.disable) {
                  // props.handleClick(code);
                  // props.setTextOnClick(props.item.text);
                }
              }}
              style={{
                // color: props.disable ? "grey" : "inherit",
                // border: "none",
                // background: "none",
                // fontFamily: "VoltePlay-Medium, sans-serif",
                // fontSize: "14px",
              }}
              className={
                !onClick
                  ? "chat-label action-tab action-button"
                  : "chat-label-select action-tab"
              }
            ></input>
          </form>
        ) : data && data !== "undefined" ? (
          <form target="_blank" action={!props.disable && url} method="POST">
            {/* <input type="hidden" name="url" value={url} /> */}
            <input
              type="hidden"
              name={Object.keys(data)[0]}
              value={data[Object.keys(data)[0]]}
            ></input>
            <input
              type="submit"
              value={props.item.text}
              onClick={() => {
                if (!props.disable) {
                  // props.handleClick(code);
                  // props.setTextOnClick(props.item.text);
                }
              }}
              style={{
                // fontFamily: "VoltePlay-Medium, sans-serif",
                // fontSize: "14px",
                // color: props.disable ? "grey" : "inherit",
                // border: "none",
                // background: "none",
              }}
              className={
                !onClick
                  ? "chat-label action-tab action-button"
                  : "chat-label-select action-tab"
              }
            ></input>
          </form>
        ) : (
          <a
            onClick={() => {
              if (!props.disable) {
                // props.handleClick(code);
                // props.setTextOnClick(props.item.text);
                // handleClick()
                props.redirectClick(code);
                setOnClick(true)
              }
            }}
            href={!props.disable && props.item.url}
            style={{
              // color: props.disable ? "grey" : "inherit",
              // fontFamily: "VoltePlay-Medium, sans-serif",
              // fontWeight :'500'
              // fontSize: "15px",
            }}

            target="_blank"
            className={
          !onClick
            ? "chat-label action-tab action-button"
            : "chat-label-select action-tab"
        }
          >
            {props.item.text}
          </a>
        )}
      </span>
    </div>
  );
};

export default MessageRedirect;
